import { api } from "../../api";

/**
 * Billing endpoints (Stripe portal + summary).
 *
 * NOTE: These rely on auth cookies + parent-company headers set in baseQuery.
 */
const billingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBillingSummary: builder.query({
      query: ({ limit = 36 } = {}) => `billing/summary?limit=${limit}`,
    }),
    createCheckoutSession: builder.mutation({
      query(body) {
        return {
          url: "billing/checkout-session",
          method: "POST",
          body,
        };
      },
    }),
    createBillingPortalSession: builder.mutation({
      query(body) {
        return {
          url: "billing/portal",
          method: "POST",
          body,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBillingSummaryQuery,
  useCreateCheckoutSessionMutation,
  useCreateBillingPortalSessionMutation,
} = billingApi;




